import React from 'react';
import { useState, useEffect, useContext } from "react";
import Axios from "axios";
import { Table } from 'react-bootstrap';
import LoadingTable from './LoadingTable';
import { thai_date, handleResizeDisplay, checkGroupsUser, getlocalStorage, combineDuplicateUnits, } from '../function/functionALL';
import * as XLSX from 'xlsx/dist/xlsx.full.min.js';
import { FaFileExcel, } from "react-icons/fa";
import { YearContext } from '../components/usecontext/YearContext';
import Swal from "sweetalert2";
import CheckNoContent from './CheckNoContent';
const TableReport = ({ unitname }) => {

    const [selectedTableReport, setSelectedTableReport] = useState(1);
    const { Token, DataToken_ } = getlocalStorage();
    const role = checkGroupsUser(DataToken_.groups)
    const role_openRole = role?.openRole
    const [isStacked, setIsStacked] = useState(false);
    const DateTime = new Date()
    const [AllData1, setAllData1] = useState([]);
    const [AllData2, setAllData2] = useState([]);
    const handleTableRound1 = (tableNumber) => {
        setSelectedTableReport(tableNumber);
    };
    const [loadingTable, setloadingTable] = useState(true); ////ทำงาน
    const { yearcurrent } = useContext(YearContext); 
    useEffect(() => {
        handleResizeDisplay(setIsStacked);

        if (unitname === undefined) {

            if (selectedTableReport === 1) {
                fetchDataReport1();
            }
            fetchDataReport2();


        } else {
            if (selectedTableReport === 1) {
                GetReport1unit();
            }
            GetReport2unit();

        }

    }, [selectedTableReport, unitname, yearcurrent]);

    const fetchDataReport1 = async () => {
        try {
            setloadingTable(true)
            const response = await Axios.get(process.env.REACT_APP_API_TESTROUND + `report_summary/?budget_year=${yearcurrent}&round=1`, {
                headers: {
                    Authorization: "Token " + Token,
                },
            });

            const allData = response.data;
            // console.log('allData ครั้งที่ 1', allData);

            const combinedData = combineDuplicateUnits(allData);
            // console.log("ข้อมูลที่รวมแล้ว 1", combinedData);
            // const groupedData = calculateSumsByUnit(allData); // จัดกลุ่มข้อมูลตาม unit
            // // console.log('Grouped Data by Unit with Sums ครั้งที่ 1:', groupedData);

            // const summaryData = getSummaryData(groupedData);   // สรุปข้อมูลเป็นราย unit        
            // // console.log('summaryData',summaryData)

            setAllData1(combinedData)
            setloadingTable(false);

        } catch (error) {
            if (error.response && error.response.status === 401) {
                localStorage.removeItem("Token_");
                localStorage.removeItem("Token");
            }
            console.error(error);

              Swal.fire({
                icon: "error",
                text:"มีข้อมูลไม่ครบตามวงรอบ"
                
            });
        }
    };
    const fetchDataReport2 = async () => {
        try {


            setloadingTable(true)
            const response = await Axios.get(process.env.REACT_APP_API_TESTROUND + `report_summary/?budget_year=${yearcurrent}&round=2`, {
                headers: {
                    Authorization: "Token " + Token,
                },
            });

            const allData = response.data;
            // console.log('allData  ครั้งที่ 2', allData);
            const combinedData = combineDuplicateUnits(allData);
            // console.log("ข้อมูลที่รวมแล้ว 2", combinedData);
            // const groupedData = calculateSumsByUnit(allData); // จัดกลุ่มข้อมูลตาม unit
            // // console.log('Grouped Data by Unit with Sums  ครั้งที่ 2:', groupedData);


            // const summaryData = getSummaryData(groupedData);  // สรุปข้อมูลเป็นราย unit
            // // console.log('Summary Data  ครั้งที่ 2:', summaryData);           
            // // setAllData2(summaryData)

            setAllData2(combinedData)
            setloadingTable(false);
        } catch (error) {
            if (error.response && error.response.status === 401) {
                localStorage.removeItem("Token_");
                localStorage.removeItem("Token");
            }
            console.error(error);

              Swal.fire({
                icon: "error",
                text:"มีข้อมูลไม่ครบตามวงรอบ"
                
            });
        }
    };

    const GetReport1unit = async () => {
        try {
            setloadingTable(true)
            const response = await Axios.get(process.env.REACT_APP_API_TESTROUND + `report_summary/?budget_year=${yearcurrent}&round=1`, {
                headers: {
                    Authorization: "Token " + Token,
                },
            });

            let allData = response.data.filter(item => item.unit === unitname);
            // console.log('allData ครั้งที่ 1', allData);

            const combinedData = combineDuplicateUnits(allData);
            // console.log("ข้อมูลที่รวมแล้ว 1", combinedData);
            // const groupedData = calculateSumsByUnit(allData); // จัดกลุ่มข้อมูลตาม unit
            // // console.log('Grouped Data by Unit with Sums ครั้งที่ 1:', groupedData);

            // const summaryData = getSummaryData(groupedData);   // สรุปข้อมูลเป็นราย unit        
            // // console.log('summaryData',summaryData)

            setAllData1(combinedData)
            setloadingTable(false);

        } catch (error) {
            if (error.response && error.response.status === 401) {
                localStorage.removeItem("Token_");
                localStorage.removeItem("Token");
            }
            console.error(error);

            Swal.fire({
              icon: "error",
              text:"มีข้อมูลไม่ครบตามวงรอบ"
              
          });
        }
    };
    const GetReport2unit = async () => {
        try {


            setloadingTable(true)
            const response = await Axios.get(process.env.REACT_APP_API_TESTROUND + `report_summary/?budget_year=${yearcurrent}&round=2`, {
                headers: {
                    Authorization: "Token " + Token,
                },
            });

            let allData = response.data.filter(item => item.unit === unitname);
            // console.log('allData  ครั้งที่ 2', allData);
            const combinedData = combineDuplicateUnits(allData);
            // console.log("ข้อมูลที่รวมแล้ว 2", combinedData);
            // const groupedData = calculateSumsByUnit(allData); // จัดกลุ่มข้อมูลตาม unit
            // // console.log('Grouped Data by Unit with Sums  ครั้งที่ 2:', groupedData);


            // const summaryData = getSummaryData(groupedData);  // สรุปข้อมูลเป็นราย unit
            // // console.log('Summary Data  ครั้งที่ 2:', summaryData);           
            // // setAllData2(summaryData)

            setAllData2(combinedData)
            setloadingTable(false);
        } catch (error) {
            if (error.response && error.response.status === 401) {
                localStorage.removeItem("Token_");
                localStorage.removeItem("Token");
            }
            console.error(error);

            Swal.fire({
              icon: "error",
              text:"มีข้อมูลไม่ครบตามวงรอบ"
              
          });
        }
    };

    //     const airWorkerData1 = AllData1.map(item => ({
    //         unit: item.unit,
    //         groundWorker: item.air_worker['ผู้ทำการภาคพื้น'],
    //         airWorker: item.air_worker['ผู้ทำการในอากาศ'],
    //     }));
    // console.log(airWorkerData1)
    //     const airWorkerData2 = AllData2.map(item => ({
    //         unit: item.unit,
    //         groundWorker: item.air_worker['ผู้ทำการภาคพื้น'],
    //         airWorker: item.air_worker['ผู้ทำการในอากาศ'],
    //     }));

    // const exportToExcel = () => {
    //     console.log('TableRound data:', TableRound);


    //     const workbook = XLSX.utils.book_new();
    //     const fullData = [['สรุปผลการทดสอบสมรรถภาพทางกาย']];


    //     if (!Array.isArray(TableRound) || TableRound.length === 0) {
    //         console.error("TableRound is empty or not an array");
    //         return;
    //     }




    //     // สร้าง tableData โดยตรวจสอบค่าต่างๆ
    //     const tableData = TableRound.map((data) => [
    //         data.unit || "",
    //         data.num_tested !== undefined ? data.num_tested : 0,
    //         data.num_not_tested !== undefined ? data.num_not_tested : 0,
    //         data.num_pass !== undefined ? data.num_pass : 0,
    //         data.num_no_pass !== undefined ? data.num_no_pass : 0,
    //         data.num_all_send_report !== undefined ? data.num_all_send_report : 0,
    //         data.percentagenum_pass_test_3_stations !== undefined ? data.percentagenum_pass_test_3_stations.toFixed(2) : 0,
    //     ]);



    //     const finalData = [...fullData, ...tableData];
    //     console.log('Final data:', finalData);


    //     const worksheet = XLSX.utils.aoa_to_sheet(finalData);
    //     console.log('worksheet data:', worksheet);

    //     worksheet['!merges'] = [
    //         { s: { r: 0, c: 0 }, e: { r: 0, c: 6 } },
    //         { s: { r: 1, c: 0 }, e: { r: 2, c: 0 } },
    //         { s: { r: 1, c: 1 }, e: { r: 1, c: 4 } },
    //         { s: { r: 1, c: 5 }, e: { r: 1, c: 6 } },
    //     ];


    //     const addBorderAndCenter = (cell) => {
    //         if (!worksheet[cell]) worksheet[cell] = {};
    //         worksheet[cell].s = {
    //             border: {
    //                 top: { style: 'thin', color: 'black' },
    //                 left: { style: 'thin', color: 'black' },
    //                 bottom: { style: 'thin', color: 'black' },
    //                 right: { style: 'thin', color: 'black' },
    //             },
    //             alignment: { horizontal: 'center', vertical: 'center' },
    //         };
    //     };



    //     const headers = [
    //         { cell: 'A1', value: 'สรุปผลการทดสอบสมรรถภาพทางกาย' },
    //         { cell: 'A2', value: 'ชื่อหน่วย' },
    //         { cell: 'B2', value: 'กำลังพลทั้งหมดที่ได้รับรายงาน' },
    //         { cell: 'F2', value: 'ทดสอบครบ 3 ประเภท' },
    //         { cell: 'B3', value: 'ทดสอบครบ 3 ประเภท' },
    //         { cell: 'C3', value: 'ทดสอบ 1-2 ประเภท' },
    //         { cell: 'D3', value: 'ไม่เข้ารับการทดสอบ' },
    //         { cell: 'E3', value: 'รวม' },
    //         { cell: 'F3', value: 'ผ่านเกณฑ์' },
    //         { cell: 'G3', value: 'คิดเป็นร้อยละ' },
    //         { cell: 'H3', value: 'ha ha ha' },
    //     ];

    //     headers.forEach(({ cell, value }) => {
    //         worksheet[cell] = { v: value, t: 's' };
    //         addBorderAndCenter(cell);
    //     });


    //     tableData.forEach((data, rowIndex) => {
    //         const row = rowIndex + 4 // เริ่มจาก row 4
    //         worksheet[`A${row}`] = { v: data[0] }; // ชื่อหน่วย
    //         worksheet[`B${row}`] = { v: data[1] }; // num_tested
    //         worksheet[`C${row}`] = { v: data[2] }; // num_not_tested
    //         worksheet[`D${row}`] = { v: data[3] }; // num_pass
    //         worksheet[`E${row}`] = { v: data[4] }; // num_no_pass
    //         worksheet[`F${row}`] = { v: data[5] }; // num_all_send_report
    //         worksheet[`G${row}`] = { v: data[6] }; // percentagenum_pass_test_3_stations
    //         worksheet[`H${row}`] = { v: data[3] }; // percentagenum_pass_test_3_stations
    //         worksheet[`I${row}`] = { v: data[3] }; // percentagenum_pass_test_3_stations


    //         ['A', 'B', 'C', 'D', 'E', 'F', 'G'].forEach(col => {
    //             addBorderAndCenter(`${col}${row}`);
    //         });

    //     });
    //     worksheet["G50"] = {v : 1524};


    //     const columnWidths = [
    //         { wch: 20 }, // A
    //         { wch: 30 }, // B
    //         { wch: 25 }, // C
    //         { wch: 25 }, // D
    //         { wch: 10 }, // E
    //         { wch: 15 }, // F
    //         { wch: 15 }, // G
    //     ];
    //     worksheet['!cols'] = columnWidths;

    //     XLSX.utils.book_append_sheet(workbook, worksheet, "สรุปผลการทดสอบสมรรถภาพทางกาย");

    //     console.log("Total rows in tableData:", tableData.length);
    //     console.log("Table data:", tableData);
    //     console.log("Table data length:", tableData.length);
    //     XLSX.writeFile(workbook, "Report.xlsx");

    // };


    // const exportToExcel = () => {
    //     const ws = XLSX.utils.json_to_sheet(
    //         TableRound.map((Data, i) => ({
    //             "หน่วย": Data.unit,
    //             "ทดสอบครบทั้ง 3 ประเภท": Data.num_test_3_stations,
    //             "ทดสอบ 1-2 ประเภท": Data.num_test_1_2_stations,
    //             "ไม่เข้ารับการทดสอบ": Data.num_not_tested,
    //             "รวม": Data.num_test_3_stations + Data.num_test_1_2_stations + Data.num_not_tested,
    //             "ผ่านเกณฑ์": Data.num_pass_all_score,
    //             "คิดเป็นร้อยละ": Data.percentagenum_pass_test_3_stations.toFixed(2)
    //         }))
    //     );

    //     const wb = XLSX.utils.book_new();
    //     XLSX.utils.book_append_sheet(wb, ws, "TableRound Data");

    //     // Trigger file download
    //     XLSX.writeFile(wb, 'TableRoundData.xlsx');
    // };


    // Example exportToExcel function
    const exportToExcel = () => {
        const fileName = `สรุปผลการทดสอบสมรรถภาพทางกาย ${yearcurrent + 543} ${selectedTableReport === 1 ? "วงรอบ 1" : "วงรอบ 2"}.xlsx`;

        const ws = XLSX.utils.json_to_sheet(
            TableRound.map((Data) => ({
                "หน่วย": Data.unit,
                "ทดสอบครบทั้ง 3 ประเภท (ภาคพื้น)": Data.air_worker["ผู้ทำการภาคพื้น"].num_test_3_stations,
                "ทดสอบ 1-2 ประเภท (ภาคพื้น)": Data.air_worker["ผู้ทำการภาคพื้น"].num_test_1_2_stations,
                "ไม่เข้ารับการทดสอบ (ภาคพื้น)": Data.air_worker["ผู้ทำการภาคพื้น"].num_absent_with_reason,
                "รวม (ภาคพื้น)":
                    Data.air_worker["ผู้ทำการภาคพื้น"].num_test_3_stations +
                    Data.air_worker["ผู้ทำการภาคพื้น"].num_test_1_2_stations +
                    Data.air_worker["ผู้ทำการภาคพื้น"].num_absent_with_reason,

                "ทดสอบครบทั้ง 3 ประเภท (ภาคอากาศ)": Data.air_worker["ผู้ทำการในอากาศ"].num_test_3_stations,
                "ทดสอบ 1-2 ประเภท (ภาคอากาศ)": Data.air_worker["ผู้ทำการในอากาศ"].num_test_1_2_stations,
                "ไม่เข้ารับการทดสอบ (ภาคอากาศ)": Data.air_worker["ผู้ทำการในอากาศ"].num_absent_with_reason,
                "รวม (ภาคอากาศ)":
                    Data.air_worker["ผู้ทำการในอากาศ"].num_test_3_stations +
                    Data.air_worker["ผู้ทำการในอากาศ"].num_test_1_2_stations +
                    Data.air_worker["ผู้ทำการในอากาศ"].num_absent_with_reason,
                "ผ่านเกณฑ์ (ภาคพื้น)": Data.air_worker["ผู้ทำการภาคพื้น"].num_pass_150,
                "คิดเป็นร้อยละ (ภาคพื้น)":
                    ((Data.air_worker["ผู้ทำการภาคพื้น"].num_pass_150 || 0) /
                        (Data.air_worker["ผู้ทำการภาคพื้น"].num_test_3_stations || 1) * 100).toFixed(2),
                "ผ่านเกณฑ์ (ภาคอากาศ)": Data.air_worker["ผู้ทำการในอากาศ"].num_pass_210,
                "คิดเป็นร้อยละ (ภาคอากาศ)":
                    ((Data.air_worker["ผู้ทำการในอากาศ"].num_pass_210 || 0) /
                        (Data.air_worker["ผู้ทำการในอากาศ"].num_test_3_stations || 1) * 100).toFixed(2),
                "รวม (ผ่านเกณฑ์)":
                    (Data.air_worker["ผู้ทำการภาคพื้น"].num_pass_150 || 0) +
                    (Data.air_worker["ผู้ทำการในอากาศ"].num_pass_210 || 0),
                "คิดเป็นร้อยละ (รวม)":
                    (((Data.air_worker["ผู้ทำการภาคพื้น"].num_pass_150 || 0) +
                        (Data.air_worker["ผู้ทำการในอากาศ"].num_pass_210 || 0)) /
                        ((Data.air_worker["ผู้ทำการภาคพื้น"].num_test_3_stations || 0) +
                            (Data.air_worker["ผู้ทำการในอากาศ"].num_test_3_stations || 0) || 1) * 100).toFixed(2),
            }))
        );

        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "สรุปผลการทดสอบสมรรถภาพทางกาย");

        // Trigger file download
        XLSX.writeFile(wb, fileName);
    };

    const TableRound = selectedTableReport === 1 ? AllData1 : AllData2

    return (
        <div className="p-2 pb-0 pb-1 ">
            <div className="card col-sm-12 col-xs-12 " style={{ backgroundColor: "rgb(247, 247, 247, 0.68)" }}>
                <div className="card-body rounded pt-3">
                    <div className="row pt-3 pt-md-2" >
                        <div className="col-12 col-md-12 col-lg-10 card-title fw-bold text-center text-md-start p-1 ps-md-2 d-md-flex justify-content-between" style={{ color: "#000000" }}>
                            <span className="fw-bold col-12 col-md-6 col-lg-6 justify-content-end" style={{ color: "#000000", fontSize: "16px" }}>สรุปผลการทดสอบสมรรถภาพทางกาย<span>|  ณ {thai_date(DateTime,"shortdate")}</span>
                            </span>

                        </div>
                        <div>

                        </div>
                    </div>
                    {/* ปุ่มสำหรับสลับตาราง */}
                    <div className=" justify-content-center justify-content-md-end d-flex pb-2 ">
                        <div className="col-12 row d-flex justify-content-center  ">
                            <div className="col-4 "></div>
                            <div className="col-12 col-md-4  "> <p className="text-center  fw-bold " style={{ fontSize: "14px" }}>{selectedTableReport === 1 ? "วงรอบ 1" : "วงรอบ 2"}</p></div>

                            <div className="col-12 col-md-4 text-md-end text-center  ">
                                <div className="btn-group col-lg-7 col-12" role="group" aria-label="Basic example">

                                    <button type="button" className="btn btn-outline-secondary" style={{ fontSize: "12px", background: selectedTableReport === 1 ? "#666699" : "none", borderWidth: "1px", color: selectedTableReport === 1 ? "white" : "#666699" }} onClick={() => handleTableRound1(1)}>วงรอบ 1 </button>
                                    <button type="button" className="btn btn-outline-secondary" style={{ fontSize: "12px", background: selectedTableReport === 2 ? "#666699" : "none", borderWidth: "1px", color: selectedTableReport === 2 ? "white" : "#666699" }} onClick={() => handleTableRound1(2)}>วงรอบ 2 </button>

                                </div> <button type="button" className="btn btn-sm btn-primary mt-3 col-12 col-lg-7" onClick={exportToExcel} style={{ border: "none", background: "rgba(75, 192, 192)", height: "30px" }}>Export {selectedTableReport === 1 ? "วงรอบ 1 " : "วงรอบ 2 "} <FaFileExcel size={"15px"} /></button>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 p-0 m-0   ">
                        <p></p>
                        <div className="card-body p-0">
                            <div className="overflow-auto ">
                                <div style={{ height: "auto" }}>
                                    {loadingTable ? (
                                        <LoadingTable />
                                    ) : (
                                        TableRound.length === 0 ? <CheckNoContent /> : (
                                            <Table responsive className={isStacked ? 'table-stacked' : 'table_content table table-hover table  table-striped '}>
                                                <thead >
                                                    <tr style={{ fontSize: "10px", textAlign: "center", width: "3%", minWidth: "60px", backgroundColor: "#666699", height: "60px", color: "white" }} >
                                                        <th rowSpan={3} style={{ fontSize: "10px", verticalAlign: "middle", textAlign: "center", width: "3%", minWidth: "60px", backgroundColor: "#666699", height: "60px", color: "white" }}>
                                                            <p>ชื่อหน่วย</p>
                                                        </th>
                                                        <th colSpan={8} style={{ fontSize: "10px", textAlign: "center", width: "3%", minWidth: "60px", backgroundColor: "#666699", height: "60px", color: "white" }}>
                                                            <p>กำลังพลทั้งหมดที่ได้รับรายงาน</p>
                                                        </th>
                                                        <th colSpan={7} style={{ fontSize: "10px", textAlign: "center", width: "3%", minWidth: "60px", backgroundColor: "#666699", height: "60px", color: "white" }}>
                                                            <p>ทดสอบครบ 3 ประเภท</p>
                                                        </th>
                                                    </tr>
                                                    <tr style={{ fontSize: "10px", textAlign: "center", width: "3%", minWidth: "60px", backgroundColor: "#666699", height: "60px", color: "white" }} >
                                                        <th colSpan={4} style={{ fontSize: "10px", textAlign: "center", width: "3%", minWidth: "60px", backgroundColor: "#88cad1", height: "60px", color: "white" }}>
                                                            <p>ภาคพื้น</p>
                                                        </th>
                                                        <th colSpan={4} style={{ fontSize: "10px", textAlign: "center", width: "3%", minWidth: "60px", backgroundColor: "#7a9ac6", height: "60px", color: "white" }}>
                                                            <p>ภาคอากาศ</p>
                                                        </th>
                                                        <th colSpan={2} style={{ fontSize: "10px", textAlign: "center", width: "3%", minWidth: "60px", backgroundColor: "#88cad1", height: "60px", color: "white" }}>
                                                            <p>ภาคพื้น</p>
                                                        </th>
                                                        <th colSpan={2} style={{ fontSize: "10px", textAlign: "center", width: "3%", minWidth: "60px", backgroundColor: "#7a9ac6", height: "60px", color: "white" }}>
                                                            <p>ภาคอากาศ</p>
                                                        </th>


                                                        <th rowSpan={2} style={{ fontSize: "10px", textAlign: "center", width: "3%", minWidth: "60px", backgroundColor: "#666699", height: "60px", color: "white" }}>
                                                            <p>ผ่านเกณฑ์</p>
                                                        </th>
                                                        <th rowSpan={2} style={{ fontSize: "10px", textAlign: "center", width: "3%", minWidth: "60px", backgroundColor: "#666699", height: "60px", color: "white" }} >
                                                            <p>คิดเป็นร้อยละ</p>
                                                        </th>
                                                    </tr>
                                                    <tr style={{ minWidth: "60px" }}>
                                                        <th colSpan={1} style={{ fontSize: "10px", textAlign: "center", width: "3%", minWidth: "60px", backgroundColor: "#88cad1", height: "50px", color: "white" }}>
                                                            <p>ทดสอบครบ 3 ประเภท</p>
                                                        </th>
                                                        <th colSpan={1} style={{ fontSize: "10px", textAlign: "center", width: "3%", minWidth: "60px", backgroundColor: "#88cad1", height: "50px", color: "white" }}>
                                                            <p>ทดสอบ 1-2 ประเภท</p>
                                                        </th>
                                                        <th colSpan={1} style={{ fontSize: "10px", textAlign: "center", width: "3%", minWidth: "60px", backgroundColor: "#88cad1", height: "50px", color: "white" }}>
                                                            <p>ไม่เข้ารับการทดสอบ</p>
                                                        </th>
                                                        <th colSpan={1} style={{ fontSize: "10px", textAlign: "center", width: "3%", minWidth: "60px", backgroundColor: "#88cad1", height: "50px", color: "white" }}>
                                                            <p>รวม</p>
                                                        </th>
                                                        <th colSpan={1} style={{ fontSize: "10px", textAlign: "center", width: "3%", minWidth: "60px", backgroundColor: "#7a9ac6", height: "50px", color: "white" }}>
                                                            <p>ทดสอบครบ 3 ประเภท</p>
                                                        </th>
                                                        <th colSpan={1} style={{ fontSize: "10px", textAlign: "center", width: "3%", minWidth: "60px", backgroundColor: "#7a9ac6", height: "50px", color: "white" }}>
                                                            <p>ทดสอบ 1-2 ประเภท</p>
                                                        </th>
                                                        <th colSpan={1} style={{ fontSize: "10px", textAlign: "center", width: "3%", minWidth: "60px", backgroundColor: "#7a9ac6", height: "50px", color: "white" }}>
                                                            <p>ไม่เข้ารับการทดสอบ</p>
                                                        </th>
                                                        <th colSpan={1} style={{ fontSize: "10px", textAlign: "center", width: "3%", minWidth: "60px", backgroundColor: "#7a9ac6", height: "50px", color: "white" }}>
                                                            <p>รวม</p>
                                                        </th>
                                                        <th colSpan={1} style={{ fontSize: "10px", textAlign: "center", width: "3%", minWidth: "60px", backgroundColor: "#88cad1", height: "50px", color: "white" }}>
                                                            <p>ผ่านเกณฑ์</p>
                                                        </th>
                                                        <th colSpan={1} style={{ fontSize: "10px", textAlign: "center", width: "3%", minWidth: "60px", backgroundColor: "#88cad1", height: "50px", color: "white" }} >
                                                            <p>คิดเป็นร้อยละ</p>
                                                        </th>
                                                        <th colSpan={1} style={{ fontSize: "10px", textAlign: "center", width: "3%", minWidth: "60px", backgroundColor: "#7a9ac6", height: "50px", color: "white" }}>
                                                            <p>ผ่านเกณฑ์</p>
                                                        </th>
                                                        <th colSpan={1} style={{ fontSize: "10px", textAlign: "center", width: "3%", minWidth: "60px", backgroundColor: "#7a9ac6", height: "50px", color: "white" }} >
                                                            <p>คิดเป็นร้อยละ</p>
                                                        </th>
                                                    </tr>
                                                </thead>

                                                <tbody style={{ backgroundColor: "rgb(247, 247, 247, 0.7)" }}>

                                                    {TableRound.map((Data, i) => (
                                                        loadingTable ? (
                                                            <LoadingTable />
                                                        ) :
                                                            (
                                                                <tr className="raw" key={i} >
                                                                    <td className="text-center" data-label="หน่วย" style={{ fontSize: "10px", backgroundColor: "#d0d9ff", verticalAlign: "middle" }} >{Data.unit}</td>
                                                                    <td className="text-center" style={{ fontSize: "10px", verticalAlign: "middle" }} data-label="ทดสอบครบทั้ง 3 ประเภท(ภาคพื้น)">{Data.air_worker["ผู้ทำการภาคพื้น"].num_test_3_stations}</td>
                                                                    <td className="text-center" style={{ fontSize: "10px", verticalAlign: "middle" }} data-label="ทดสอบ 1-2 ประเภท(ภาคพื้น)">{Data.air_worker["ผู้ทำการภาคพื้น"].num_test_1_2_stations}</td>
                                                                    <td className="text-center" style={{ fontSize: "10px", verticalAlign: "middle" }} data-label="ไม่เข้ารับการทดสอบ(ภาคพื้น)">{Data.air_worker["ผู้ทำการภาคพื้น"].num_absent_with_reason}</td>
                                                                    <td className="text-center" style={{ fontSize: "10px", verticalAlign: "middle" }} data-label="รวม(ภาคพื้น)">{Data.air_worker["ผู้ทำการภาคพื้น"].num_test_3_stations + Data.air_worker["ผู้ทำการภาคพื้น"].num_test_1_2_stations + Data.air_worker["ผู้ทำการภาคพื้น"].num_absent_with_reason}  </td>
                                                                    <td className="text-center" style={{ fontSize: "10px", verticalAlign: "middle" }} data-label="ทดสอบครบทั้ง 3 ประเภท(ภาคอากาศ)">{Data.air_worker["ผู้ทำการในอากาศ"].num_test_3_stations}</td>
                                                                    <td className="text-center" style={{ fontSize: "10px", verticalAlign: "middle" }} data-label="ทดสอบ 1-2 ประเภท(ภาคอากาศ)">{Data.air_worker["ผู้ทำการในอากาศ"].num_test_1_2_stations}</td>
                                                                    <td className="text-center" style={{ fontSize: "10px", verticalAlign: "middle" }} data-label="ไม่เข้ารับการทดสอบ(ภาคอากาศ)">{Data.air_worker["ผู้ทำการในอากาศ"].num_absent_with_reason}</td>
                                                                    <td className="text-center" style={{ fontSize: "10px", verticalAlign: "middle" }} data-label="รวม(ภาคอากาศ)">{Data.air_worker["ผู้ทำการในอากาศ"].num_test_3_stations + Data.air_worker["ผู้ทำการในอากาศ"].num_test_1_2_stations + Data.air_worker["ผู้ทำการในอากาศ"].num_absent_with_reason}  </td>

                                                                    <td className="text-center" style={{ fontSize: "10px", verticalAlign: "middle" }} data-label="ครบ 3 ประเภท (ภาคพื้น) ผ่านเกณฑ์">{Data.air_worker["ผู้ทำการภาคพื้น"].num_pass_150}</td>

                                                                    <td className="text-center" style={{ fontSize: "10px", verticalAlign: "middle" }} data-label="ครบ 3 ประเภท (ภาคพื้น) คิดเป็นร้อยละ">

                                                                        {((Data.air_worker["ผู้ทำการภาคพื้น"].num_pass_150 / (Data.air_worker["ผู้ทำการภาคพื้น"].num_test_3_stations || 1)) * 100).toFixed(2)}%                                                                  </td>
                                                                    <td className="text-center" style={{ fontSize: "10px", verticalAlign: "middle" }} data-label="ครบ 3 ประเภท (ภาคอากาศ) ผ่านเกณฑ์">{Data.air_worker["ผู้ทำการในอากาศ"].num_pass_210}</td>

                                                                    <td className="text-center" style={{ fontSize: "10px", verticalAlign: "middle" }} data-label="ครบ 3 ประเภท (ภาคอากาศ) คิดเป็นร้อยละ">
                                                                        {((Data.air_worker["ผู้ทำการในอากาศ"].num_pass_210 / (Data.air_worker["ผู้ทำการในอากาศ"].num_test_3_stations || 1)) * 100).toFixed(2)}%
                                                                    </td>
                                                                    <td className="text-center" style={{ fontSize: "10px", verticalAlign: "middle", backgroundColor: isStacked ? "RGB(2, 117, 216,0.10)" : "" }} data-label="ผ่านเกณฑ์">{Data.air_worker["ผู้ทำการภาคพื้น"].num_pass_150 + Data.air_worker["ผู้ทำการในอากาศ"].num_pass_210}</td>
                                                                    <td className="text-center" style={{ fontSize: "10px", verticalAlign: "middle", backgroundColor: isStacked ? "RGB(2, 117, 216,0.10)" : "" }} data-label="คิดเป็นร้อยละ">
                                                                        {(
                                                                            (
                                                                                (Data.air_worker["ผู้ทำการภาคพื้น"].num_pass_150 || 0) + (Data.air_worker["ผู้ทำการในอากาศ"].num_pass_210 || 0)
                                                                            ) /
                                                                            (
                                                                                (Data.air_worker["ผู้ทำการภาคพื้น"].num_test_3_stations || 0) + (Data.air_worker["ผู้ทำการในอากาศ"].num_test_3_stations || 0) || 1
                                                                            ) * 100
                                                                        ).toFixed(2)}%
                                                                    </td>


                                                                </tr>
                                                            )

                                                    ))}

                                                </tbody>
                                            </Table>
                                        ))}
                                </div>
                            </div>


                        </div>

                    </div>

                </div>



            </div>
        </div>
    );
};

export default TableReport;
